// Sys Data Type ID
export const Sys_Data_Type_Text = 101;
export const Sys_Data_Type_Number = 102;
export const Sys_Data_Type_Decimal = 103;
export const Sys_Data_Type_Currency = 104;
export const Sys_Data_Type_DateTime = 105;
export const Sys_Data_Type_Phone = 106;
export const Sys_Data_Type_Email = 107;
export const Sys_Data_Type_Name_First = 108;
export const Sys_Data_Type_USState = 109;
export const Sys_Data_Type_Name_Middle = 110;
export const Sys_Data_Type_Name_Last = 111;
export const Sys_Data_Type_Name_Full_Name = 112;
export const Sys_Data_Type_Date = 113;
